export default __webpack_public_path__ + "static/media/Strong-professional-icon.972f9e71.png";